export default [
  {
    id: 1,
    postName: '市场专员',
    age: null,
    salary: '4-6K',
    workYear: '不限',
    workAddress: '福建省福州市平潭县',
    education: '不限',
    peopleNum: '2',
    workContent: [
      '1.负责公司智能化项目落地及推广；',
      '2.根据市场营销计划，完成部门销售指标；',
      '3.拓展新的合作渠道，维护现有渠道，与合作方建立长期稳定的合作关系；',
      '4.管理维护客户关系以及客户间的长期战略合作计划；',
      '5.具备良好的沟通技巧和服务意识，能够妥善处理突发状况，对接项目需求，满足客户提出的需求；',
    ],
    workRequirements: [
      '1.市场营销等相关专业优先，接受应届毕业生；',
      '2.有C1/C2驾照；',
      '3.有较强的沟通能力、工作责任心，适应接受能力强。',
      '4.品行端正、有良好的学习能力及抗压能力。',
    ],
  },
  {
    id: 2,
    postName: '售前支持',
    age: null,
    salary: '8-13K',
    workYear: '1-3年',
    workAddress: '福建省福州市平潭县',
    education: '大专',
    peopleNum: '1',
    workContent: [
      '1. 负责公司智能化系统、信息化系统等产品的售前技术支持，包括客户咨询解答、需求分析、方案设计等工作。',
      '2. 根据客户实际需求，制定有针对性的技术解决方案，提升客户对产品的满意度。',
      '3. 配合销售完成公司智能化项目落地及推广；',
      '4. 具备良好的沟通技巧和服务意识，能够妥善处理突发状况，对接项目需求，满足客户提出的需求；',
    ],
    workRequirements: [
      '1.有C1/C2驾照；',
      '2.具备智能化系统、信息化系统等相关领域的技术背景和知识储备。',
      '3.具备方案设计、标书制作、技术谈判等售前支持能力。',
      '4.具备较强的学习能力和创新思维，能够快速掌握新技术和新产品。',
      '5.有智能化相关工作经验优先；',
    ],
  },
  {
    id: 3,
    postName: '法务',
    age: null,
    salary: '5-8K',
    workYear: '1-3年',
    workAddress: '福建省福州市平潭县',
    education: '本科',
    peopleNum: '1',
    workContent: [
      '1.负责公司合同的拟定、审核、修订;',
      '2.负责对公司合同及其他法律文本的合规审查;',
      '3.协助公司的风险控制提供合理建议和处理方案;',
      '4.为公司各部门提供法律咨询；',
      '5.完成上级交办的其他工作。',
    ],
    workRequirements: [
      '1.本科以上学历，法律相关专业优先考虑;',
      '2.有一定法学基础知识，对相关法律相对熟悉；',
      '3.有较强的沟通能力、工作责任心，适应接受能力强;',
      '4.能熟练使用各种办公软件。',
    ],
  },
  {
    id: 4,
    postName: '审计专员',
    age: null,
    salary: '6-9K',
    workYear: '3-5年',
    workAddress: '福建省福州市平潭县',
    education: '本科',
    peopleNum: '1',
    workContent: [
      '1、根据公司整体战略规划，拟定并完善内部审计制度和流程，制定审计计划;',
      '2、根据年度审计工作计划，组织进行公司各项审计;',
      '3、拟定审计方案，起草审计报告和管理建议书等审计文书;',
      '4、及时发现公司潜在问题和风险，提出改进意见;',
      '5、出具内部审计报告，将审计结果上报公司领导;',
      '6、检查公司财务及相关部门审计意见的执行情况;',
      '7、负责审计过程中与相关部门的协调和沟通;',
      '8、配合公司聘请的外部审计机构，全面负责公司内、外部财务审计工作;',
      '9、跟踪监控公司的财产和资金使用情况、流程运行状况，分析资产报表，判断企业运行效率，及时发现风险并提出改进建议;',
      '10、熟练使用各种财务软件，各种办公软件;',
    ],
    workRequirements: [
      '1、本科及以上学历，审计、财务等相关专业。持有相关证书者优先；',
      '2、在财务审计、运营审计或信息技术审计方面拥有至少3年的经验，熟悉审计流程、方法和技巧；',
    ],
  },
  {
    id: 5,
    postName: '智能化实施项目经理',
    age: null,
    salary: '10-11K',
    workYear: '3-5年',
    workAddress: '福建省福州市平潭县',
    education: '大专',
    peopleNum: '1',
    workContent: [
      '1.负责智能化项目的整体实施，包括进度安排、现场监管、质量把控、安全管理等。',
      '2.有项目售前方案设计及招投标经验，负责项目成本控制，包括材料采购、设备租赁、人力成本等方面的预算与核算，确保项目在预算范围内高效完成。',
      '3.负责与业主、设计、监理等各方进行沟通与协调，确保项目需求得到满足，处理项目实施过程中出现的各种问题，确保项目顺利进行。',
      '4.负责项目的验收工作，确保项目符合质量标准。',
      '5.负责工程资料的收集、整理与归档，确保工程资料的完整性和准确性。',
    ],
    workRequirements: [
      '1.大专及以上学历，机电一体化、电气自动化、自动化控制等相关专业。',
      '2.具有3年以上智能化施工管理工作经验，能独立管理一个项目的进度、质量。',
      '3.熟悉智能化、弱电、安防建设行业相关政策、技术标准和规范。',
      '4.熟练使用CAD制图软件和相关工程软件，掌握建筑智能化工程技术、工程预决算等知识。',
      '5.持有C1驾照、电工证、一/二级建造师（机电工程）、PMP等证书者优先。',
      '6.具有良好的施工组织能力，能很好地分析和解决施工中出现的问题，具有良好的沟通、协调、管理能力，能够处理好与各方的关系。',
    ],
  },
  {
    id: 6,
    postName: '财务主管',
    age: null,
    salary: '7-9K',
    workYear: '1-3年',
    workAddress: '福建省福州市平潭县',
    education: '硕士',
    peopleNum: '1',
    workContent: [
      '1、负责财务部的日常管理工作，监督执行财务工作；',
      '2、负责公司税收的筹划和管理，组织完成公司税务申报和纳税工作；',
      '3、具备良好财务分析能力，能够提供及时、准确的财务分析数据，为经营决策提供依据；',
      '4、负责会计帐务管理：公司账务、应收款、应付款、借支及对账等，并做好账务核对检查工作等；',
    ],
    workRequirements: [
      '1.研究生及以上学历，会计、财务等相关专业，有大公司工作经历可放宽至本科;',
      '2.诚信正直，爱岗敬业，认真仔细，高度的责任感和良好的职业道德;',
      '3.良好的学习能力、独立工作能力和扎实的财务知识。',
    ],
  },
  {
    id: 7,
    postName: '财务专员',
    age: null,
    salary: '5-9K',
    workYear: '1-3年',
    workAddress: '福建省福州市平潭县',
    education: '硕士',
    peopleNum: '1',
    workContent: [
      '1.负责公司日常账务处理；',
      '2.负责接收各项银行到款进账凭证，并传递到有关的制单人员。',
      '3.负责记账凭证的装订，保存，归档财务相关资料，相关财务文档台账的登记及管理；',
      '4.完成上级交代的其他事项',
    ],
    workRequirements: [
      '1.研究生及以上学历，会计、财务等相关专业，有大公司工作经历可放宽至本科;',
      '2.诚信正直，爱岗敬业，认真仔细，高度的责任感和良好的职业道德;',
      '3.良好的学习能力、独立工作能力和扎实的财务知识。',
    ],
  },
  {
    id: 8,
    postName: '客户经理',
    age: 30,
    salary: '10K',
    workYear: '3-5年',
    workAddress: '北京市北京市东城区',
    education: '博士',
    peopleNum: '1',
    workContent: [
      '1、负责公司产品的销售及推广；',
      '2、根据公司制定的区域销售目标，制定本区域的销售计划，并对目标进行分解，组织落实；',
      '4、对区域市场进行客户开发，完成经销网络布局；',
      '4、开发新客户、维护老客户，拓宽业务渠道，并定期拜访市区新、老客户',
      '5、每月负责制定区域产品推广活动方案，对每次活动进行活动后总结分析；',
    ],
    workRequirements: [
      '1、高中以上学历，22-40岁；能吃苦，耐劳，热爱销售行业，具有良好的沟通表达能力，组织、策划能力；',
      '2、半年以上快消品行业工作经验，有酒水行业经验的优先考虑，退伍军人优先考虑；',
      '3、无经验者公司可培养；',
    ],
    companyBenefits: [
      '1、每月150元全勤奖励；',
      '2、员工生日福利；',
      '3、传统节假日按照国家规定休假并实物或现金形式发放福利；',
      '4、给员工统一办理社会保险；',
      '5、公司工作氛围良好，员工关系融洽，集团内部不定期组织丰富多彩的大型团建活动；',
      '6、集团公司提供广阔的发展平台和晋升渠道；',
      '7、年终奖、股权激励。',
      '8、管食宿',
    ],
  },
  {
    id: 9,
    postName: '高级运营经理',
    age: 25,
    salary: '5K',
    workYear: '1-3年',
    workAddress: '河北省石家庄市长安区',
    education: '不限',
    peopleNum: '5',
    workContent: [
      '1、能独立负责部门的产品运营工作，包括但不限于收集整理部门的产品需求、对接产品经理、跟进需求、追踪产品上线后的表现；',
      '2、能够根据运营目标，结合产品现状建立有效数据跟踪机制，根据业务发展要求推动优化运营方案，并负责线上相关产品推广活动的实施执行，达成kpi指标；',
      '3、持续跟进产品效果，分析用户行为、需求、了解竞争对手动向，并进行竞争分析；',
      '4、根据运营现状，产品化现有流程，优化业务效率。',
    ],
    workRequirements: [
      '1、有良好的分析能力和逻辑思维，有责任感、抗压能力强，可独立完成项目；',
      '2、具有洞察力，独立分析能力，以及较强的学习创新能力、语言表达力；',
      '3、对产品运营有热情，对创新及解决具有挑战性的问题充满激情；',
      '4、能做prd，原型图，有银行工作经验或者对分期电商，社区电商、网赚行业熟悉者优先；',
      '5、具备抗压性，执行力、学习能力强。',
    ],
  },
  {
    id: 10,
    postName: 'Java技术专家/架构师',
    age: 24,
    salary: '5K',
    workYear: '1-3年',
    workAddress: '河北省石家庄市长安区',
    education: '不限',
    peopleNum: '5',
    message: '岗位众多，欢迎沟通。Java 初级、高级、专家、架构师、负责人等各级别岗位、各类业务都有招聘需求，以下为部分举例：',
    subTitle: '【Java开发工程师-【用户增长】】',
    workContent: [
      '1、承担关键高并发分布式系统的研发工作，打造一流的用户增长引擎，涵盖用户增长，投放优化，程序化购买，用户分享传播等方向；',
      '2、参与设计系统技术方案，核心代码开发和系统调优，包括高性能后端引擎，海量数据存储和流式传输，用户数据中心，复杂业务后台等模块；',
      '3、参与各类创新优化、专项技术调研，新技术引入等前瞻项目。',
    ],
    workRequirements: [
      '1、计算机或相关专业本科以上学历，具备1年以上的大型Web应用开发和架构经验；',
      '2、熟悉Linux开发环境，熟练使用Java和面向对象设计开发；',
      '3、熟悉大型分布式、高并发、高可用性系统设计开发；',
      '4、具备优秀的逻辑思维能力，对解决挑战性问题充满热情；有强烈的上进心和求知欲，对新事物抱有好奇心；',
      '5、有过用户增长，用户自动运营，投放优化，程序化购买相关经验的优先；',
      '6、使用过Facebook，Google，百度，腾讯等广告平台，有过投放优化经验者优先。',
    ],
    subTitle_2: '【高级Java开发工程师（Server）-【主App】】',
    workContent_2: [
      '我们是一群对技术有着极致追求的后端工程师，负责建设公司级的业务平台、业务中台，致力于为所有业务的开发提效。',
      '作为公司春节等大型活动的主力研发团队，加入我们即有机会参与百万级QPS的高并发项目挑战。',
      '1、参与快手核心产品需求的开发，深入发掘和分析业务需求，撰写技术方案和系统设计，以及相关的代码开发；',
      '2、接受高并发、海量数据的挑战，分析和发现系统的优化点，负责推动系统的性能和可用性的提升；',
      '3、接受中台/平台系统设计与实现复杂度的挑战，分析和发现系统的优化点，负责推动系统的合理性、可靠性、可用性的提升；',
      '4、为团队引入创新的技术、创新的解决方案，用创新的思路解决问题。',
    ],
    workRequirements_2: [
      '1、三年以上Java开发经验，有扎实的计算机基础知识和编程功底；',
      '2、精通多线程编程，熟悉JVM，熟悉常见的开源分布式中间件、缓存、消息队列等，熟悉MySQL，熟悉Linux下的DevOps；',
      '3、熟悉面向对象设计，有一定的系统架构设计能力；',
      '4、热爱技术，对代码质量和开发规范有近乎苛刻的要求，善于沟通与团队协作；',
      '5、有大型分布式、高并发、高负载、高可用性系统设计和稳定性经验优先。',
    ],
  },
  {
    id: 11,
    postName: '高级前端工程师',
    age: 28,
    salary: '12K',
    workYear: '3-5年',
    workAddress: '天津市天津市和平区',
    education: '硕士',
    peopleNum: '2',
    workContent: [
      '计算机或相关专业毕业，2年以上工作经验',
      '对前端工程化与模块化开发有一定了解，并有实践经验（如webpack/gulp等）',
      '熟练掌握HTML、CSS，JS，至少精通ReactJS、VueJS或其他一门MVVM框架',
      '熟悉并关注前端主流库和框架，理解框架的设计思想及实现原理',
      '熟悉一门服务端语言（如PHP/NodeJS)优先',
      '对前端技术有持续的热情，较强的沟通能力',
    ],
    workRequirements: [],
  },
  {
    id: 12,
    postName: '资深内核工程师',
    age: 30,
    salary: '6K',
    workYear: '3-5年',
    workAddress: '北京市北京市东城区',
    education: '博士',
    peopleNum: '1',
    workContent: [
      '1、快手内部服务器的linux内核维护、升级工作；',
      '2、结合服务特点对linux内核进行性能调优；',
      '3、内核新技术的研究和应用；',
      '4、容器相关技术研究和改进。',
    ],
    workRequirements: [
      '1、精通linux内核，至少阅读过内核中的主要模块内存管理、I/O子系统、网络子系统三者之一的源代码 ；',
      '2、熟悉Linux平台上的C语言编程，熟悉多进程多线程编程，熟悉socket编程 ；',
      '3、优秀的分析问题和解决问题的能力，对解决具有挑战性问题充满激情；',
      '4、有内核开源社区patch贡献优先考虑；',
      '5、良好的沟通能力和团队协作精神，严谨的工作态度与高质量意识 ；',
      '6、善于学习新的知识，动手能力强，有进取心。',
    ],
  },
]
